import { ReactNode, useMemo } from 'react';

// material-ui
import { AppBar, AppBarProps, IconButton, Toolbar, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project import
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';

// assets
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import Logo from 'components/logo';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

interface Props {
  open: boolean;
  variant?: 'main' | 'blank' | 'landing' | 'landing-auth' | 'simple' | 'component' | 'auth' | undefined;
  handleDrawerToggle?: () => void;
}

const Header = ({ open, variant, handleDrawerToggle }: Props) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));
  // header content
  const headerContent = useMemo(() => <HeaderContent variant={variant} />, []);

  const iconBackColorOpen = theme.palette.mode === 'dark' ? 'grey.200' : 'grey.300';
  const iconBackColor = theme.palette.mode === 'dark' ? 'background.default' : 'grey.100';

  // common header
  const mainHeader: ReactNode = (
    <Toolbar>
      {/* {matchDownMD && ( */}
        <IconButton
          aria-label="open drawer"
          onClick={handleDrawerToggle}
          edge="start"
          color="secondary"
          variant="light"
          sx={{ color: 'text.primary', bgcolor: open ? iconBackColorOpen : iconBackColor, ml: { xs: 0, lg: -1 } }}
        >
          {!open ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </IconButton>
      {/* )} */}
      {headerContent}
    </Toolbar>
  );

  // common header
  const mainHeaderAuthLanding: ReactNode = (
    <Toolbar>
      <Logo reverse to="/" />
      {headerContent}
    </Toolbar>
  );

  const appBar: AppBarProps = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      bgcolor: 'rgba(255,255,255,0.85)',
      backdropFilter: 'blur(12px)',
      zIndex: theme.zIndex.appBar
    }
  };

  if (variant === 'landing-auth') {
    return <AppBar {...appBar}> {mainHeaderAuthLanding}</AppBar>;
  }
  return (
    <>
      {!matchDownMD ? (
        <AppBarStyled open={open} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
};

export default Header;
